import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Nav } from 'react-bootstrap';
//import './Sidebar.css';
import { useUser } from '../context/UserContext';

function Sidebar() {
  const [collapsed, setCollapsed] = useState(false);
  const { user } = useUser();

  return (
    <div className={`sidebar ${collapsed ? 'collapsed' : ''}`}>
      <div className="sidebar-header">
        <button className="toggle-btn" onClick={() => setCollapsed(!collapsed)}>
          ☰
        </button>
        {!collapsed && <h5 className="mt-2">Panel</h5>}
      </div>

      <Nav className="flex-column mt-3">
        {/*<Nav.Link as={Link} to="/contacts">Contactos</Nav.Link>*/}

        {/* 🔹 Mapas visibles para todos los usuarios */}
        {/*<Nav.Link as={Link} to="/mapas/guayaquil">Mapa Guayaquil</Nav.Link>
        <Nav.Link as={Link} to="/mapas/quito">Mapa Quito</Nav.Link>
        <Nav.Link as={Link} to="/clusters">Clusters</Nav.Link>*/}

        {user?.user.roles?.some((r: string) => ["admin", "viewer"].includes(r)) && (
          <Nav.Link as={Link} to="/contacts">Contactos</Nav.Link>
        )}

        {user?.user.roles?.some((r: string) => ["admin", "clusters"].includes(r)) && (
          <Nav.Link as={Link} to="/locate-contacts">Localizacion de Contactos</Nav.Link>
        )}

        {user?.user.roles?.some((r: string) => ["admin", "clusters"].includes(r)) && (
          <Nav.Link as={Link} to="/ciiu-contacts">Contactos por Actividad</Nav.Link>
        )}

        {user?.user.roles?.some((r: string) => ["admin", "clusters"].includes(r)) && (
          <Nav.Link as={Link} to="/geo">Resumen Contactos</Nav.Link>
        )}

        {user?.user.roles?.some((r: string) => ["admin", "clusters"].includes(r)) && (
          <Nav.Link as={Link} to="/clusters">Clusters</Nav.Link>
        )}

        {user?.user.roles?.some((r: string) => ["admin", "viewer", "search"].includes(r)) && (
          <Nav.Link as={Link} to="/select-contacts">Seleccionar Contactos</Nav.Link>
        )}

        {/* 🔹 Opciones solo para admin */}
        {user?.user.role === 'admin' && (
          <>
            <Nav.Link as={Link} to="/usuarios">Usuarios</Nav.Link>
          </>
        )}
      </Nav>
    </div>
  );
}

export default Sidebar;